import { alertLabels } from '../attributes/LocatorAlerts';
import LocatorAlertsEqualsComparator from './LocatorAlertsEqualsComparator';
import AliasEqualsSelector from '../../attributes/filters/AliasEqualsSelector';

/**
 * Options returns an array of objects that based off the alertLabels and looks like this:
 * [ {
     name : 'Position Pending',
     value : CONSTANTS.POSITION_PENDING
    },...
   ]
 */

const options = Object.entries(alertLabels()).map(([value, name]) => ({
  name,
  value
}));
export default AliasEqualsSelector.create(LocatorAlertsEqualsComparator, options);